class User {
	private _uuid: string;
	firstName: string;
	lastName: string;
	firebaseAuth: string;
	p_enabled: boolean;
	// photos: Photo[];

	constructor(
		uuid: string,
		firstName: string,
		lastName: string,
		firebaseAuth: string,
		p_enabled: boolean,
		// photos: Photo[]
	) {
		this._uuid = uuid;
		this.firstName = firstName;
		this.lastName = lastName;
		this.firebaseAuth = firebaseAuth;
		this.p_enabled = p_enabled;
		// this.photos = photos;
	}

	get uuid(): string {
		return this._uuid;
	}
}

export default User;
